import styles from './NavigationDesktop.module.scss'
import { getNavigationItems } from 'components/page-header/utils'
import Link from 'next/link'
import { Button, Dropdown, DropdownItem } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'
import { useRouter } from 'next/router'
import { useGetLanguage } from 'hooks/useGetLanguage'

const NavigationDesktop = () => {
  // i18n
  const { t } = useTranslation('header')
  const language = useGetLanguage()

  // Router
  const router = useRouter()

  return (
    <nav className={styles.navigation}>
      <ul>
        {getNavigationItems(language).map(({ key, route, children }) => (
          <li key={key}>
            {route ? (
              <Link href={route} className={styles.item}>
                {t(($) => $.navigation[key])}
              </Link>
            ) : (
              <Dropdown
                customTrigger={
                  <Button variant="tertiary" trailingIcon="chevronDown" className={styles.item}>
                    {t(($) => $.navigation[key].root)}
                  </Button>
                }
              >
                {children?.map(({ key, route }) =>
                  route ? <DropdownItem key={key} onClick={() => router.push(route)} label={t(($) => $.navigation[key])} /> : null
                )}
              </Dropdown>
            )}
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default NavigationDesktop
